import { render, staticRenderFns } from "./ConfirmSignupFormCreationModal.vue?vue&type=template&id=4922c970&scoped=true&"
import script from "./ConfirmSignupFormCreationModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmSignupFormCreationModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmSignupFormCreationModal.vue?vue&type=style&index=0&id=4922c970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4922c970",
  null
  
)

export default component.exports